import React from 'react';
import styled, { keyframes } from 'styled-components';
import Typography from './Typography';
import Button from './Button';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DialogContainer = styled.div`
  background-color: white;
  border-radius: 16px;
  padding: 24px;
  width: 90%;
  max-width: 320px;
  animation: ${fadeIn} 0.2s ease-out;
  z-index: 1003;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Title = styled.div`
  margin-bottom: 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 12px;
  .title {
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
  }
  .description {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
    white-space: pre-wrap;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
`;

const AlertDialog = ({ isOpen, onClose, title, description, buttons = [], buttonStyle }) => {
  if (!isOpen) return null;

  return (
    <Overlay onClick={onClose}>
      <DialogContainer onClick={e => e.stopPropagation()}>
        <Title>
          {title && <div className="title">{title}</div>}
          {description && <div className="description">{description}</div>}
        </Title>
        <ButtonContainer style={buttonStyle}>
          {buttons.map((button, index) => (
            <Button
              {...button}
              key={index}
              onClick={button.onClick}
              color={button.color || 'white'}
              value={button.label}
              style={button.style}
              variant={'outline'}
            />
          ))}
        </ButtonContainer>
      </DialogContainer>
    </Overlay>
  );
};

export default AlertDialog;
